export default __webpack_public_path__ + "static/media/women.958dfd70.png";